module.exports = "<app-header></app-header>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 pr-0\">\r\n        <app-leftnav></app-leftnav>\r\n    </div>\r\n    <div class=\"col-md-9 details px-0\">\r\n        <p class=\"header\">Survey</p>\r\n          <iframe class=\"w-100\" [src]=\"sanitizer.bypassSecurityTrustResourceUrl(loginService.link)\">\r\n            </iframe>\r\n    </div>\r\n</div>\r\n<app-footer></app-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/survey.component.html
// module id = ./src/app/survey/survey.component.html
// module chunks = main